import { combineReducers } from 'redux'

import deleteNode from './task/delete'
import get from './task/get'
import post from './task/post'
import put from './task/put'

export default combineReducers({
  delete: deleteNode,
  get,
  post,
  put
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/controls/task.js